import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';
import { UserRoleType } from '../../types/user-roles/user-roles.types';
import { apps, moduleList, permissions } from '../rolesAndPermission';
import { userPermissionContent } from '../userPermissionContent';

const timeCardModule = moduleList.find((feature) => feature.key === 'timecards');
const autoTimeOffPermissionKey = userPermissionContent.feature.timecard.auto_time_off_notification_visible;
export const momTimeCardFeatures = {
  [autoTimeOffPermissionKey]: {
    featureId: 204,
    featureName: 'Auto Closeout Notification',
    featureKey: 'auto-time-off-notification',
  },
} as const;

export const timeCardModulePermission = {
  [autoTimeOffPermissionKey]: {
    ...momTimeCardFeatures[autoTimeOffPermissionKey],
    roleKey: UserRoleType.MANAGER,
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: timeCardModule?.id,
    key: autoTimeOffPermissionKey,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
